<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
            <el-form-item label="子公司" prop="subcompanyIdList">
              <el-select multiple  v-model="dataForm.subcompanyIdList" @change="getSupCompanyList" class="input-width">
                <el-option
                    v-for="item in supCompanyList"
                    :key="item.id"
                    :label="item.orgName"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          <el-form-item label="工厂名称:">
                <el-select v-model="dataForm.werks" filterable clearable placeholder="请选择工厂" @change="queryHandle">
                    <el-option v-for="item in factoryList" :key="item.orgCode" :label="item.orgName" :value="item.orgCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="物料编码:">
                <el-input size="small" v-model="dataForm.matnr" placeholder="物料编码" clearable @blur="queryHandle"></el-input>
            </el-form-item>
            <el-form-item label="计划日期区间:" label-width="100px">
                <el-date-picker unlink-panels v-model="dataForm.perxx" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable @blur="getDataList">
                </el-date-picker>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" @click="queryHandle" icon="el-icon-search">
                    查询
                </el-button>
                <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建
                </el-button> -->
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" bProject style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" border :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="werks" header-align="center" align="left" label="工厂" width="150">
                </el-table-column> -->
                <!-- <el-table-column prop="lifnr" header-align="center" align="left" label="供应商" width="150">
                </el-table-column> -->
                <el-table-column prop="name1" header-align="center" align="center" label="供应商名称" width="170">
                </el-table-column>
                <el-table-column prop="matnr" header-align="center" align="left" label="物料编码" width="150">
                </el-table-column>
                <el-table-column prop="maktx" header-align="center" align="left" label="物料描述" width="150">
                </el-table-column>
                <el-table-column prop="meins" header-align="center" align="center" label="单位" width="70">
                    <template slot-scope="scope">
                        <span>{{getUnitName(scope.row.meins)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="perxx" header-align="center" align="center" :formatter="dateFormat" label="计划期间" width="150">
                </el-table-column>
                <el-table-column prop="zmenge11" header-align="center" align="right" label="M+1数量" width="120">
                </el-table-column>
                <el-table-column prop="zmenge22" header-align="center" align="right" label="M+2数量" width="120">
                </el-table-column>
                <el-table-column prop="zmenge33" header-align="center" align="right" label="M+3数量" width="120">
                </el-table-column>
                <el-table-column prop="zfbrq" header-align="center" align="center" label="发布日期" :formatter="dateFormat" width="200">
                </el-table-column>
                 <el-table-column prop="name2" header-align="center" align="center" label="工厂名称" width="300">
                    <template slot-scope="scope">
                        <span>{{getFactoryName(scope.row.werks)}}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column header-align="center" align="center" label="操作" width="190" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>
                    </template>
                </el-table-column> -->
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20,50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <!-- <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update> -->
    </div>
</div>
</template>

<script>
import {
    getFactoryList,
    getUnitList
} from '@/controller/systemData'
import {
    getForecastList,
    removeForecast
} from '@/controller/sap'
// import AddOrUpdate from './sap-purchaseForecast-add-or-update'
import moment from 'moment'
import {supCompanyList, workList} from "../../../../controller/sys";
// require('@/mock/mockContract');
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                werks: '',
                name1: '',
                matnr: '',
                perxx: '',
                subcompanyIdList:'',
            },
            dataList: [],
            tenantList: [],
            factoryList: [],
            unitList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,
            supCompanyList: [],
        }
    },
    components: {
        // AddOrUpdate
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 220
            }
        }
    },
    activated() {
        this.getDataList()
        // 工厂
        this.getFactoryList()
        // 单位
        this.getUnitList()
    },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        getFactoryList() {
            getFactoryList({
                factoryCode: "",
                factoryDesc: "",
                address: "",
                post: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            });
        },
        getFactoryName(code) {
            const factory = this.factoryList.find(factory => factory.factoryCode === code)
            return factory ? factory.factoryDesc : ''
        },
        // 单位
        getUnitList() {
            getUnitList({
                code: "",
                name: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            });
        },
        getUnitName(code) {
            const unit = this.unitList.find(unit => unit.code === code)
            return unit ? unit.name : ''
        },
        queryHandle(){
            this.pageIndex = 1
            this.getDataList()
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            getForecastList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                'name1': this.dataForm.name1,
                werks: this.dataForm.werks,
                matnr: this.dataForm.matnr,
                subcompanyIdList: this.dataForm.subcompanyIdList,
                'perxxStart': this.dataForm.perxx==null?this.dataForm.perxx:this.dataForm.perxx[0],//计划日区间开始
                'perxxEnd': this.dataForm.perxx==null?this.dataForm.perxx:this.dataForm.perxx[1]//计划日区间结束
            }).then(data => {
                console.log(data, 'data')
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
              this.getSupCompanyList()
              this.getFactoryListVue()
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        viewHandle(row) {
            console.log(row)
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'view')
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            console.log(row)
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'edit')
            })
        },
        // 删除
        deleteHandle(id) {
            console.log(id)
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                removeForecast({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
      //获取子公司列表
      getSupCompanyList(){
        supCompanyList().then(res=>{
          if(res && res.code == '00'){
            this.supCompanyList = res.body;
          }
        })
      },
      //获取工厂的数据
      getFactoryListVue() {
        workList(
        ).then((data) => {
          if (data && data.code === '00') {
            this.factoryList = data.body
          }
        })
      },
    }
}
</script>

<style lang="scss" scoped>
.button-danger {
    color: #F56C6C
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.text-waming {
    color: #E6A23C;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}
</style>
